import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';
import { fallbackLng, languages } from '@/i18n/settings';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: languages,

  // Used when no locale matches
  defaultLocale: fallbackLng,
});

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
